import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

export const StyledCenteredCircularProgress = styled(CircularProgress)`
  display: flex;
  margin: auto;
`;
